import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import request from './request';
export function logout() {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/logout`;
    fetchData
      .post(url, {
        body: JSON.stringify({ rpProps: { sc: 10025, ec: 10026 } }),
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

export const getDeadPoolConfig = (projectName: string, keys: string[]) => {
  const DEADPOOL_CONFIG = `${API2_HOST}/v3/config/web`;

  return request
    .post(DEADPOOL_CONFIG, {
      data: {
        project_name: projectName,
        keys,
      },
      useCache: true,
    })
    .then((res: any) => {
      const {
        result: { data = [] },
      } = res || { result: { data: [] } };
      if (data?.length > 0) {
        const newData: any = {};
        data.forEach(({ name, ...reset }: { name: string }) => {
          newData[name] = { ...reset };
        });
        return newData;
      }
      return [];
    });
};
